import { useNavigate, useParams } from 'react-router-dom';

import { IssuePanel } from './IssuePanel';

/**
 * `/projects/:key/issues/:issueKey` — задача на отдельной полноэкранной
 * странице со своей ссылкой. Панель доски остаётся быстрым просмотром.
 */
export function IssuePage() {
  const { key = '', issueKey = '' } = useParams<{ key: string; issueKey: string }>();
  const navigate = useNavigate();

  return (
    <IssuePanel
      variant="page"
      issueKey={issueKey}
      projectKey={key}
      onClose={() => navigate(`/projects/${key}/board`)}
    />
  );
}
